import React, {useState} from "react"

import {
  List,
  ListItemLocation,
  Pagination,
  SearchField,
  DownloadButton
} from "~/components/"
import {useDebounce, useApi} from "~/hooks/"
import {withUserFeedback} from "~/helpers/"
import {useTranslation} from "react-i18next"

export const LocationList = () => {
  const {t} = useTranslation()
  const [params, setParams] = useState({
    "search[query]": "",
    page: 0
  })
  const setPage = page => setParams({"search[query]": query, page})

  const [query, setQuery] = useState("")
  useDebounce(query, 1000, () => {
    setParams({
      "search[query]": query,
      page: 0
    })
  })
  const paramsQueryString = new URLSearchParams(params).toString()

  const data = useApi("/locations", {
    params,
    headers: {
      Accept: "application/vnd.shelf.v2"
    }
  })
  const locations = data && data.items
  const totalPages = data && data.total_pages

  return (
    <div className="sh-searchable-list">
      <div className="searchbar">
        <SearchField
          onChange={setQuery}
          placeholder={t("locations.searchPlaceholder")}
        />
        <DownloadButton
          label={t("locations.downloadButton", {format: "(.xlsx)"})}
          endpoint={`/locations.xlsx?${paramsQueryString}`}
          v2
          filename="filtered_locations.xlsx"
          mimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          automaticRetry
          key={JSON.stringify(params) + "xlsx"}
        />
        <DownloadButton
          label={t("locations.downloadButton", {format: "(.csv)"})}
          endpoint={`/locations.csv?${paramsQueryString}`}
          v2
          filename="filtered_locations.csv"
          mimeType="text/csv"
          automaticRetry
          key={JSON.stringify(params) + "csv"}
        />
      </div>
      <div className="results">
        {withUserFeedback(
          () => (
            <React.Fragment>
              <List items={locations} itemRenderer={ListItemLocation}>
                <p>{t("locations.noLocation")}</p>
              </List>
              <Pagination
                currentPage={params.page}
                totalPages={totalPages}
                onPageChange={setPage}
              />
            </React.Fragment>
          ),
          [data]
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/list/LocationList.js